
import { FlowDefinition } from "../../../../core/flows/FlowDefinition";
import { RequestCorporateAccountStepDeclaration } from "./Steps/RequestCorporateAccount";
import { requestCorporateAccountInitStepDeclaration } from "./Steps/RequestCorporateAccountInit";
import { RequestCorporateAccountTransition } from "./Transition/RequestCorporateAccountTransition";


export const requestCorporateAccountFlow = new FlowDefinition("RequestCorporateAccountFlow");

requestCorporateAccountFlow.addStep(requestCorporateAccountInitStepDeclaration)
requestCorporateAccountFlow.addStep(RequestCorporateAccountStepDeclaration)

requestCorporateAccountFlow.addLink("RequestCorporateAccountInit_Step", "RequestCorporateAccount_Step")

requestCorporateAccountFlow.addTransition(RequestCorporateAccountTransition, "RequestCorporateAccountInit_Step");

requestCorporateAccountFlow.setStartStep("RequestCorporateAccountInit_Step");
